import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const GuaranteeSearch = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!query) return;
    setLoading(true);
    setError('');
    setResults([]);
    try {
      const res = await axios.get(`/api/guarantee-search?query=${query}`);
      setResults(res.data);
    } catch (err) {
      setError('No matching products found.');
    }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto px-2 sm:px-4 py-2 w-full">
      <h1 className="text-3xl font-bold mb-4">Guarantee Search</h1>

      <div className="mb-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
        <input
          type="text"
          placeholder="Search by Product ID, Custom Name, or Phone Number"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
          className="border p-2 rounded w-full"
        />
        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white px-4 py-2 rounded w-full sm:w-auto"
        >
          Search
        </button>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {results.length > 0 && results.map((item, idx) => (
        <div key={idx} className="border p-4 rounded shadow mb-4 bg-white w-full">
          <p><strong>Order ID:</strong> {item.orderId}</p>
          <p><strong>Product ID:</strong> {item.productId}</p>
          <p><strong>Product Name:</strong> {item.modelName}</p>
          {item.customName && <p><strong>Custom Name:</strong> {item.customName}</p>}
          <p><strong>Customer Name:</strong> {item.customerName}</p>
          <p><strong>Phone Number:</strong> {item.phoneNumber}</p>
          <p><strong>Guarantee:</strong> {item.guarantee}</p>
          <p>
            <strong>Guarantee Expiration:</strong>{" "}
            {item.guaranteeExpiration
              ? new Date(item.guaranteeExpiration).toLocaleDateString()
              : 'Not Found'}
          </p>
          <Link
            to={
              item.source === 'custom'
                ? `/guarantee/${item.orderId}?productId=${item.productId}`
                : `/guarantee/direct/${item.orderId}/${item.productId}`
            }
            className="block w-full sm:w-auto text-center mt-3 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            View Guarantee
          </Link>
        </div>
      ))}
    </div>

  );
};

export default GuaranteeSearch;
